import React,{useState} from "react"
import { Link } from 'react-router-dom'

import {portfolioData, portfolioImges} from '../data/data'

import Lightbox from 'react-18-image-lightbox';
import "react-18-image-lightbox/style.css"

export default function ProjectFilter() {
    let [isOpen, setisOpen] = useState(false);
    let [currentImageIndex, setCurrentImageIndex] = useState(0);
    let [selectedCategory, setSelectedCategory] = useState(null);

    let handleMovePrev = () => {
      setCurrentImageIndex((prevIndex) => (prevIndex + portfolioImges.length - 1) % portfolioImges.length);
  };

  let handleMoveNext = () => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % portfolioImges.length);
  };
  let handleImageClick = (index) => {
      setCurrentImageIndex(index);
      setisOpen(true);
  };
  let currentImage = portfolioImges[currentImageIndex-1];

  let matchCategory = (category) => {
      setSelectedCategory(category);
  };

  let filteredData = selectedCategory
      ? portfolioData.filter((item) => item.category === selectedCategory)
      : portfolioData;
  return (
    <>
        <div className="row justify-content-center">
              <div className="col-12">
                  <div className="filters-group-wrap text-center">
                      <div className="filters-group">
                          <ul className="container-filter mb-0 categories-filter list-unstyled filter-options">
                              <li className={`list-inline-item categories position-relative ${selectedCategory === null ? 'active' : ''}`} onClick={() => matchCategory(null)}>All</li>
                              <li className={`list-inline-item categories position-relative ${selectedCategory === 'branding' ? 'active' : ''}`} onClick={() => matchCategory('branding')}>Branding</li>
                              <li className={`list-inline-item categories position-relative ${selectedCategory === 'designing' ? 'active' : ''}`} onClick={() => matchCategory('designing')}>Designing</li>
                              <li className={`list-inline-item categories position-relative ${selectedCategory === 'photography' ? 'active' : ''}`} onClick={() => matchCategory('photography')}>Photography</li>
                              <li className={`list-inline-item categories position-relative ${selectedCategory === 'development' ? 'active' : ''}`} onClick={() => matchCategory('development')}>Development</li>
                          </ul>
                      </div>
                  </div>
              </div>
          </div>

          <div id="grid" className="row projects-wrapper mt-4 pt-2">
            {filteredData.map((item,index)=>{
              return(
                  <div className="col-lg-3 col-md-6 spacing picture-item" key={index}>
                      <div className="work-container position-relative d-block overflow-hidden rounded">
                          <Link to="#" onClick={() => handleImageClick(item.id)} className="lightbox d-inline-block" title="">
                              <img src={item.image} className="img-fluid" alt=""/>
                          </Link>
                          <div className="content bg-white p-3">
                              <Link to="/portfolio-detail-one" className="title d-block fw-bold text-dark">{item.title}</Link>
                              <small className="text-muted">{item.name}</small>
                          </div>
                      </div>
                  </div>
              )
            })}
          </div>
            {isOpen && (
            <Lightbox
                mainSrc={currentImage}
                prevSrc={portfolioImges[(currentImageIndex + portfolioImges.length - 1) % portfolioImges.length]}
                nextSrc={portfolioImges[(currentImageIndex + 1) % portfolioImges.length]}

                onCloseRequest={() => setisOpen(false)}
                onMovePrevRequest={handleMovePrev}
                onMoveNextRequest={handleMoveNext}
            />
            )}
    </>
  )
}
